module.exports = "/_next/static/images/CollectDataTabs-3-5b6732b5d0a602c82e368b7c834a0a1c.webp";